export default {
    view: "Bekijk meer"
}